export class EnaioAddonAddUser {
    groups = false;
    multiSelection = false;
    storeFullUserName = false;
    columns: string[];
}
